import {isString} from "./index";

export const prevent = (ev) => ev && ev.preventDefault();

export const stop = (ev) => ev && ev.stopPropagation();

export const loadStyle = async (href) => {
    const link = document.createElement('link');
    link.href = href;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
};

export const onKeyDown = (key, clb) => {
    const onKey = (ev) => ev.key === key && clb();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
}

export const onKeyEscape = (clb) => onKeyDown('Escape', clb);


export const loadScript = (src, opts) => {
    const scriptToLoad = isString(src) ? {id: src, src} : src;
    return new Promise((res, rej) => {
        const script = document.createElement('script');
        const prevScript = document.querySelector(`script[src="${scriptToLoad.src}"]`);

        if (prevScript) {
            opts.onScript?.(prevScript);
            return res(scriptToLoad.id);
        }

        script.src = scriptToLoad.src;
        script.onload = () => res(scriptToLoad.id);
        script.onerror = () => rej(scriptToLoad.id);
        document.head.appendChild(script);
        opts.onScript?.(script);
    });
}

export const loadScripts = (scripts) => {
    const promises = scripts.map(script => loadScript(script));
    return Promise.allSettled(promises);
}